import { render } from "./SubNav.vue?vue&type=template&id=1fa56e2c"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__